<template>
  <header class="header">
    <HeaderPc
      v-if="mediaType === 'pc'"/>
    <HeaderSp
      v-else/>
  </header>
</template>

<script>
import { mapGetters } from 'vuex'
import HeaderPc from '@/components/organisms/HeaderPc'
import HeaderSp from '@/components/organisms/HeaderSp'

export default {
  name: 'Header',
  components: {
    mapGetters,
    HeaderPc,
    HeaderSp
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters(['textData', 'lang', 'mediaType'])
  },
  methods: {
  },
  mounted () {
  },
  created () {
  }
}
</script>

<style lang="postcss" scoped>
  @import '../../assets/css/mixins.css';
  @import '../../assets/css/variables.css';
  .header {
    display: flex;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    min-width: 960px;
    height: 80px;
    z-index: 1000;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
    overflow: hidden;
    box-sizing: border-box;
  }
  @media (--breakPoint) {
    .header {
      position: fixed;
      width: 50px;
      height: 50px;
      box-shadow: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/templates/Header.vue